<template>
  <div class="modal-phone-number-update">
    <SfModal :visible="isVisible" @close="closeModal">
      <transition name="fade" mode="out-in">
        <div class="transition-container">
          <SfAlert v-if="errorMessage" :message="errorMessage" type="danger" />
          <div class="form">
            <SfInput
              v-model.trim="fullName"
              :value="fullName"
              label="Full name"
              name="fullName"
              class="form__element form__element--half"
              :required="true"
              :valid="!$v.fullName.$error"
              :error-message="
                !$v.fullName.required
                  ? $t('Field is required')
                  : $t('Name must have at least 2 letters.')
              "
              @blur="$v.fullName.$touch()"
            />
            <SfButton
              :disabled="this.$v.$invalid || this.saving"
              @click="updateFullName"
            >
              Update
            </SfButton>
          </div>
        </div>
      </transition>
    </SfModal>
  </div>
</template>

<script>
import SfModal from "@lib/components/molecules/SfModal/SfModal";
import { notifications } from "@lib/modules/cart/helpers";
import PhoneInput from "@lib/components/atoms/PhoneInput";
import SfInput from "@lib/components/atoms/SfInput/SfInput";
import { required, minLength, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import firebase from "@lib/firebase";
import SfButton from "@lib/components/atoms/SfButton/SfButton";
import SfAlert from "@lib/components/molecules/SfAlert/SfAlert";

export default {
  name: "ModalAuthentication",
  components: { SfModal, SfButton, SfInput, SfAlert },
  data() {
    return {
      fullName: "",
      errorMessage: "",
      saving: false,
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      storedName: "user/displayName",
    }),
  },
  methods: {
    closeModal() {
      this.$emit("close", this.modalData.name);
    },
    updateFullName() {
      this.saving = true;
      const self = this;
      firebase
        .auth()
        .currentUser.updateProfile({
          displayName: this.fullName,
        })
        .then(
          async (result) => {
            const user = firebase.auth().currentUser;
            await self.$store.dispatch(
              "user/onLogin",
              firebase.auth().currentUser
            );
            this.$emit("close", this.modalData.name);
          },
          (error) => {
            console.error(error);
            this.errorMessage =
              "Could not update your account. Please try again after some time";
            this.saving = false;
          }
        );
    },
  },
  validations: {
    fullName: {
      required,
      minLength: minLength(2),
    },
  },
  created() {
    this.fullName = this.storedName;
    firebase.auth().languageCode = "en";
  },
};
</script>

<style lang="scss">
#recaptcha-container {
  width: 100%;
  min-height: 60px;
  padding-bottom: 16px;

  .grecaptcha-badge {
    position: static !important;
    margin: 0 auto;
  }
}

.modal-phone-number-update {
  .firebaseui-idp-button {
    max-width: 300px;
    padding: 16px 32px;
  }

  .sf-alert {
    padding: 16px;
  }

  .resend-timer {
    color: #888;
    font-size: var(--font-sm);
    text-align: right;

    .resend-verification-code {
      display: inline;
      --button-color: green;
      --button-font-size: var(--font-sm);
    }
  }
}
</style>
